module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/experiences/wedding/04_dining.png";